import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { push } from 'connected-react-router'

// amplify
import { API } from 'aws-amplify'
import { listProgramsByOrganization, getProgram } from './../../graphql/queries'
import { createProgram, updateProgram } from './../../graphql/mutations'

import { setLoading } from './loading'

import { Program } from '../../../API'

interface ProgramState {
    organizationPrograms: Program[],
    selectedProgram: Program | null
}

const initialState: ProgramState = {
    organizationPrograms: [],
    selectedProgram: null
}

export const getOrganizationPrograms: any = createAsyncThunk(
    'programs/getOrganizationLocations',
    async (organizationId: string, { dispatch, getState }) => {
        try {

            const { authAccount }: any = getState()

            const { data }: any = await API.graphql({
                query: listProgramsByOrganization,
                variables: {
                    organizationID: authAccount.selectedStaffProfile.organizationID
                }
            })
            const programs: Program[] = data.listProgramsByOrganization.items

            console.log('organization programs: ', programs)

            return programs
        } catch (err) {
            console.error(err)
        }
    }
)

export const updateOrganizationProgram: any = createAsyncThunk(
    'programs/updateOrganizationProgram',
    async (program: Program, { dispatch, getState }) => {
        try {

            dispatch(setLoading({
                loading: true,
                message: 'Creating your new program...'
            }))

            console.log('passed program: ', program)

            const { authAccount }: any = getState()

            if (program.id != '') {
                const createProgramResponse: any = await API.graphql({
                    query: updateProgram,
                    variables: {
                        input: {
                            id: program.id,
                            name: program.name,
                            description: program.description ? program.description : null,
                            theWhy: program.theWhy ? program.theWhy : null,
                            leadID: program.leadID ? program.leadID : null,
                            stringifiedCauses: program.stringifiedCauses ? program.stringifiedCauses : null,
                            archived: program.archived
                        }
                    }
                })

                console.log('updated program: ', createProgramResponse.data.updateProgram)

                dispatch(setLoading({
                    loading: false,
                    message: 'Loading.'
                }))

                return {
                    updatedProgram: createProgramResponse.data.updateProgram
                }
            } else {
                const createProgramResponse: any = await API.graphql({
                    query: createProgram,
                    variables: {
                        input: {
                            organizationID: authAccount.selectedStaffProfile.organizationID,
                            name: program.name,
                            description: program.description ? program.description : null,
                            theWhy: program.theWhy ? program.theWhy : null,
                            leadID: program.leadID ? program.leadID : null,
                            stringifiedCauses: program.stringifiedCauses ? program.stringifiedCauses : null,
                            archived: program.archived
                        }
                    }
                })

                console.log('created program: ', createProgramResponse.data.createProgram)

                dispatch(setLoading({
                    loading: false,
                    message: 'Loading.'
                }))

                return {
                    createdProgram: createProgramResponse.data.createProgram
                }
            }
        } catch (err) {
            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))
            console.error(err)
        }
    }
)

export const setSelectedProgram: any = createAsyncThunk(
    'programs/setSelectedProgram',
    async (programID: string, { dispatch, getState }) => {
        try {

            dispatch(setLoading({
                loading: true,
                message: 'Loading selected program...'
            }))

            await dispatch(clearSelectedProgram())

            const { data }: any = await API.graphql({
                query: getProgram,
                variables: {
                    id: programID
                }
            })

            const retrievedProgram: Program = data.getProgram

            console.log('selected program: ', retrievedProgram)

            dispatch(push(`/admin/opportunities/programs/manage?id=${programID}`))

            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))

            return {
                program: retrievedProgram
            }
        } catch (err) {
            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))
            console.error(err)
        }
    }
)

export const programsSlice = createSlice({
    name: 'programs',
    initialState,
    reducers: {
        clearLocalProgramData: (state) => {
            state.organizationPrograms = []
            state.selectedProgram = null
        },
        clearSelectedProgram: (state) => {
            state.selectedProgram = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getOrganizationPrograms.fulfilled, (state, { payload }) => {
            state.organizationPrograms = payload
        })
        builder.addCase(updateOrganizationProgram.fulfilled, (state, { payload }) => {
            if (payload && payload.updatedProgram) {
                state.selectedProgram = payload.updatedProgram
            } else if (payload && payload.createdProgram) {
                const currentOrganizationPrograms = state.organizationPrograms.slice()
                currentOrganizationPrograms.push(payload)
                state.organizationPrograms = currentOrganizationPrograms
            }
        })
        builder.addCase(setSelectedProgram.fulfilled, (state, { payload }) => {
            state.selectedProgram = payload.program
        })
    }
})

export const { clearLocalProgramData, clearSelectedProgram } = programsSlice.actions
export default programsSlice.reducer